import type {
	AlertLevel,
	AnchorsAlertsInfoModel,
	AnchorsAlertsItemModel,
} from '@/shared/generated'

import { find, map, prop, sum } from 'lodash/fp'

/**
 * Get the pricing alerts tree from the alerts and annotations
 * @param pricingAlerts - The alerts
 * @param annotations - The annotations
 * @returns - The pricing alerts tree
 */
export function getAnchorAssortmentAlertsTree(
	alerts: AnchorsAlertsInfoModel[],
	annotations?: AnchorsAlertsItemModel[]
) {
	return [
		{
			level: 'critical' as AlertLevel,
			total: sum(map(prop('anchors'), alerts)),
			alerts: alerts?.map(({ id, anchors }) => {
				const name = find({ id }, annotations)?.name ?? id

				return {
					id,
					name,
					anchors,
				}
			}),
		},
	]
}
